import { useState } from 'react';
import ticketService from '../../ticketService';
import { captureMessage } from 'modules/sentry';

const useTicketForm = ({ onSubmit = () => {} }) => {
  const [showErrors, setShowErrors] = useState(false);
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false);
  const [backendErrors, setBackendErrors] = useState({});

  const beforeOnSubmit = () => {
    return (values) => {
      //   clean backend errors
      setBackendErrors({});
      // waiting for backend
      setIsWaitingForResponse(true);
      //   trasnform the values we get from form to the format expected in backend
      const formValues = ticketService.utils.deepCopy(values);
      const dto = ticketService.dataTransformation.getTicketDtoFromFormValues({
        values: formValues,
      });

      onSubmit({ ticketDto: dto })
        //   if submit works, form does nothing
        .then(() => {
          setIsWaitingForResponse(false);
        })
        // if submit fails, form saves the error
        // the original submit could also do something after errors
        .catch((e) => {
          //   the backend will return an error body with json format
          try {
            e.response.json().then((errorBody) => {
              console.error('🔥 ~ errorBody:', errorBody);
              const dtoFormatted = JSON.stringify(dto);
              const errorBodyFormatted = JSON.stringify(errorBody);
              captureMessage(
                `Error creating ticket, dto: ${dtoFormatted}, response: ${errorBodyFormatted}`
              );
              setBackendErrors(errorBody);
              setIsWaitingForResponse(false);
            });
          } catch (eee) {
            // if the backend error is not a json, is empty or something unexpected
            // we treat that as a different errors
            setBackendErrors({
              details: 'can_not_reach_backend',
            });
            setIsWaitingForResponse(false);
          }
        });
    };
  };

  return {
    showErrors,
    setShowErrors,
    isWaitingForResponse,
    setIsWaitingForResponse,
    backendErrors,
    setBackendErrors,
    beforeOnSubmit,
  };
};

export default useTicketForm;
